<template>
  <div class="action">
    <div>
      <div class="action__title">{{ action.title }}</div>
      <div class="action__desc">{{ action.desc }}</div>
      <div v-if="!isDesktop" class="action__image">
        <div
          v-for="(id, index) in idsInArray"
          :key="index"
          class="action__image--item"
        >
          <img :src="require(`../assets/reaction${id}.png`)" />
        </div>
      </div>
      <div v-else class="action__image desktop" ref="image">
        <div :class="{ blur: modalId !== 0 }">
          <div class="desktop__top">
            <div
              v-for="id in imgsId[0]"
              :key="id"
              class="action__image--item"
              @click="handleClickItem(id)"
            >
              <img
                class="action__image--img"
                :src="require(`../assets/reaction${id}.png`)"
              />
            </div>
          </div>
          <div class="desktop__bottom">
            <div class="desktop__left">
              <div
                v-for="id in imgsId[1]"
                :key="id"
                class="action__image--item"
                @click="handleClickItem(id)"
              >
                <img
                  class="action__image--img"
                  :src="require(`../assets/reaction${id}.png`)"
                />
              </div>
            </div>
            <div class="desktop__middle">
              <div
                v-for="id in imgsId[2]"
                :key="id"
                class="action__image--item"
                @click="handleClickItem(id)"
              >
                <img
                  class="action__image--img"
                  :src="require(`../assets/reaction${id}.png`)"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="desktop__right" :class="{ blur: modalId !== 0 }">
          <div
            v-for="id in imgsId[3]"
            :key="id"
            class="action__image--item"
            @click="handleClickItem(id)"
          >
            <img
              class="action__image--img"
              :src="require(`../assets/reaction${id}.png`)"
            />
          </div>
        </div>
        <section v-show="modalId">
          <img
            :src="modalId ? require(`../assets/reaction${modalId}.png`) : ''"
            class="action__image--modal"
            v-click-outside="handleClickOutside"
          />
          <div class="action__image--mask" />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
export default {
  name: 'ActionTwo',
  data() {
    return {
      windowWidth: window.innerWidth,
      modalId: 0,
      imgsId: [
        [2, 8, 11, 10],
        [15, 16, 17, 14, 18, 19],
        [3, 7, 1, 12, 6],
        [13, 4, 5, 9],
      ],
    };
  },
  props: {
    action: {
      type: Object,
      default: () => ({}),
    },
  },
  directives: {
    ClickOutside,
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  computed: {
    isDesktop() {
      return this.windowWidth >= 768;
    },
    groupedIds() {
      const grouped = [[], [], []];
      for (let i = 0; i < this.imgIds.length; i++) {
        grouped[i % 3].push(this.imgIds[i]);
      }
      return grouped;
    },
    idsInArray() {
      const array = [];
      this.imgsId.forEach((innerArray) => {
        innerArray.forEach((id) => {
          array.push(id);
        });
      });
      return array;
    },
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    handleClickItem(id) {
      if (this.modalId) return;
      this.modalId = id;
    },
    handleClickOutside(e) {
      if (!this.modalId || e.target.className === 'action__image--img') return;
      this.modalId = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.action {
  background: #77bc1f;
  color: #fff;
  margin: 0 auto;
  padding: 117px 56px 0 56px;
  min-height: 80vh;
  position: relative;
  max-width: 100vw;
  overflow: hidden;
  min-height: calc(100vh - 85px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  @media (min-width: 768px) {
    padding: 117px 40px 0 0;
    min-height: calc(100vh - 75px);
  }

  &__title {
    font-size: 20px;
    text-align: center;
    max-width: 677px;
    color: #fff;
    margin: 0 auto;
    @media (min-width: 768px) {
      font-size: 40px;
      line-height: 60px;
    }
  }

  &__desc {
    font-weight: 350;
    font-size: 16px;
    line-height: 24px;
    max-width: 677px;
    color: #fff;
    margin: 0 auto;
    margin-top: 28px;
    @media (min-width: 768px) {
      margin-top: 34px;
      font-size: 22px;
      line-height: 33px;
    }
  }

  &__image {
    margin: 36px 0;
    position: relative;
    @media (min-width: 768px) {
      margin-top: 88px;
      display: flex;
      justify-content: flex-end;
    }
    .desktop {
      &__right {
        max-width: 363px;
        margin-left: 14px;
        div {
          background: rgba(0, 0, 0, 0);
          & + div {
            margin-top: 16.5px;
          }
        }
      }
      &__top {
        display: flex;
        flex-wrap: wrap;
        width: 570px;
        div:first-child {
          width: 271px;
          margin-right: 12px;
          background: rgba(0, 0, 0, 0);
        }
        div:nth-child(2) {
          width: 287px;
          margin-top: 0;
        }
        div:nth-child(3) {
          width: 245px;
          margin-top: 10px;
          background: rgba(0, 0, 0, 0);
        }
        div:nth-child(4) {
          width: 309px;
          margin-top: 10px;
          margin-left: 16px;
        }
      }
      &__bottom {
        display: flex;
      }
      &__left {
        width: 369px;
        div {
          background: rgba(0, 0, 0, 0);
          margin-top: 12px;
        }
        div + div {
          margin-top: 19px;
        }
      }
      &__middle {
        width: 185px;
        margin-left: 16px;
        div {
          background: rgba(0, 0, 0, 0);
          margin-top: 12px;
        }
        div + div {
          margin-top: 6.6px;
        }
      }
    }
    &--item {
      background: #fff;
      width: 100%;
      opacity: 0.8;
      &:not(:first-child) {
        margin-top: 14px;
      }
      &:hover {
        opacity: 1;
        cursor: pointer;
      }

      img {
        width: 100%;
      }
    }
    &--modal {
      background: #fff;
      position: absolute;
      width: calc(100% - 36px);
      left: 18px;
      top: 50%;
      transform: translate(0, -50%);
      z-index: 20;
    }
    &--mask {
      width: 100%;
      height: 100%;
      z-index: 10;
      position: absolute;
      top: 0;
      left: 0;
    }
  }
  .blur {
    filter: blur(4px);
    *:hover {
      opacity: 0.8;
    }
  }
}
</style>
